/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { identityDependencies } from './dependenciesIdentity.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { normDependencies } from './dependenciesNorm.generated.js';
import { qrDependencies } from './dependenciesQr.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSchur } from '../../factoriesAny.js';
export var schurDependencies = {
  identityDependencies,
  matrixDependencies,
  multiplyDependencies,
  normDependencies,
  qrDependencies,
  subtractDependencies,
  typedDependencies,
  createSchur
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSchur.generated.js
// module id = YFZ1
// module chunks = 3